import { z } from 'zod/v4';

import { simpleVehicleGroupSchema } from './vehicle-group.schema';

export const placeSetSchema = z.object({
  id: z.number(),
  name: z.string(),
  vehicleGroups: z.array(simpleVehicleGroupSchema),
  isDefault: z.boolean(),
});

export type PlaceSet = z.infer<typeof placeSetSchema>;
